const base = '/admin-patients'

export const patient = {
    get_patients: `${base}`,
    get_patients_analytics: `${base}/chart`,
}